import { useDispatch } from "react-redux";
import { useGetMessagingMutation} from "../../../Store/Builder/messaging.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";
import {appendMessagesData, setMessagesData} from "../../../Store/Slice/messagingSlice";

const useGetMessagingApi = () => {
  const dispatch = useDispatch();
  const [getMessaging] = useGetMessagingMutation();

  const get = (id, page) => {
    const body = {
      id: id,
      page: page,
    }
    dispatch(setLoader(true));
    getMessaging(body)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        if(res.page <= 1) {
          dispatch(setMessagesData(res))
        } else {
          dispatch(appendMessagesData(res))
        }
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error account", "error");
      });
  };

  return {
    get,
  };
};

export default useGetMessagingApi;
